// extracted by mini-css-extract-plugin
export default {"loading":"Loading_loading__8DVS2","flashing":"Loading_flashing__IIPeu"};